import './App.css';
import { TodoWrapper } from './components/TodoWrapper';
import '../node_modules/font-awesome/css/font-awesome.min.css'; 

function App() {
  return (
   
    <div className="App">
      <TodoWrapper  />
      <div className="footer" >Made with &nbsp; <i className="fa fa-heart  heart" ></i>  &nbsp; Aradhya Dixit</div>
  
       </div>  
)}

export default App;
